module.exports = __webpack_public_path__ + "static/media/goat.bcb81095.svg";